import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../../../app/services/account.service';
import { PortalProductsService } from '../../../app/services/portal-products.service';
import { SuperAdminService } from '../../../app/services/super-admin.service';
import { LovDataService } from '../../../app/services/lov-data.service';
import { Step } from '../../shared/step-navigation/step-navigation.component';
import { ProductFormBase } from './product-form.component';
import { ScrollToTop } from '../../../app/utils/functions';
import { GlobalValidators } from '../../../app/utils/validators';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialog } from '../../../app/shared/dialogs/dialog';
import { IdleLogoutService } from '../../../app/services/idle-logout.service';
import { GetPortalProductIdFromKey, GetPortalProductIdFromName } from '../../../app/data/portal-products';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-signup',
  templateUrl: `product-signup.component.html`,
  styleUrls: ['./product-signup.component.scss'],
})
export class ProductSignupComponent extends ProductFormBase implements OnInit, OnDestroy {
  @HostBinding('class.portal') portalClass = true;
  viewTermsAndConditions;
  toggle = false;
  currentStepIndex = 0;
  loading = false;
  submitInProgress = false;
  bankInProcessing = false;
  disableNext = false;
  productId;
  // Define the steps for product signup process
  steps: Step[] = [
    {
      id: 'account-holder',
      title: 'Account Holder',
      description: 'Enter your account holder information',
    },
    {
      id: 'bank-info',
      title: 'Bank Information',
      description: 'Enter your bank information',
    },
    {
      id: 'nominee-details',
      title: 'Nominee Details',
      description: 'Enter your nominee information',
    },
    {
      id: 'documents',
      title: 'Documents',
      description: 'Upload required documents',
    },
    {
      id: 'confirmation',
      title: 'Confirmation',
      description: 'Submit your application',
    },
  ];

  // Step management properties
  currentStep = 1;
  totalSteps = this.steps.length;
  showValidationErrors = false;
  currentUser;
  prdname;

  // Radio button options
  boTypeOptions = [
    { id: 'newBo', text: 'New Bo', description: '' },
    { id: 'linkBo', text: 'Link Bo', description: '' },
  ];
  courtesyTitleOptions = [
    { id: 'mr', text: 'Mr' },
    { id: 'mrs', text: 'Mrs' },
    { id: 'miss', text: 'Miss' },
    { id: 'dr', text: 'Dr' },
  ];
  countryOptions = [];
  brokerBranchOptions = [
    { id: 'Head Office', text: 'Head Office' },
    { id: 'mothijeel', text: 'Mothijeel' },
  ];
  residentialStatusOptions = [
    { id: 'resident', text: 'Resident' },
    { id: 'non-resident', text: 'Non-Resident' },
  ];

  bankMasterData = [];
  bankOptions = [];

  branchOptions = [];
  isCollapseSection = [];
  formInLoading;
  todayDate = new Date();
  branchInProcessing;
  constructor(
    private route: ActivatedRoute,
    accountService: AccountService,
    @Inject(DOCUMENT) private document: Document,
    fb: FormBuilder,
    portalProductsService: PortalProductsService,
    lovDataService: LovDataService,
    superAdminService: SuperAdminService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private idleLogoutService: IdleLogoutService,
    public translate: TranslateService,
  ) {
    super(fb, portalProductsService, accountService, lovDataService, superAdminService);
    if (window.innerWidth < 769) {
      this.document.body.classList.add('sidebar-collapse-in');
      this.accountService.emit(true);
    } else {
      this.document.body.classList.remove('sidebar-collapse-in');
      this.accountService.emit(false);
    }
    console.log('ProductSignupComponent: Constructor called');
    this.accountService.emitChange.subscribe((status) => (this.toggle = status));
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.prdname = this.route.snapshot.params['productId'];

    const productIdFromKey = GetPortalProductIdFromKey(this.prdname);
    if (productIdFromKey) {
      this.productId = productIdFromKey.toString();
    }

    try {
      this.formInLoading = true;
      this.countryOptions = await this.lovDataService.getCountryData('Contact.countryCode');
    } catch (e) {}
    try {
      const draftData = await this.portalProductsService.getSignupForm(this.productId, this.currentUser.id);
      console.log(draftData);
      let savedData = draftData?.values;
      this.bindForm(savedData);
      this.formInLoading = false;
      await this.loadBanks();
      console.log(savedData);
      let branchName = savedData?.branchName;
      if (savedData?.bankCode && savedData?.branchName) {
        await this.loadBranches(savedData?.bankCode);
        console.log(branchName, 136);
        this.productForm.get('branchName').setValue(branchName);
        console.log(this.productForm.get('branchName').value, 137);
      }
      this.cdRef.detectChanges();
    } catch (e) {
      this.formInLoading = false;
    }

    // Initialize idle logout for product signup module
    this.idleLogoutService.initializeIdleLogout('product-signup');

    //  lovDataPath="Contact.countryCode"

    // Initialize the product form
  }
  async bindForm(savedData?) {
    // Temporarily disable validation during form initialization
    const isInitializing = !!savedData;
    console.log(savedData);

    this.productForm = this.fb.group({
      boType: [savedData?.boType || 'newBo'],
      boId: [savedData?.boId || ''],
      accountHolderType: [savedData?.accountHolderType || 'individual'],
      courtesyTitle: [savedData?.courtesyTitle],
      gender: [savedData?.gender],
      occupation: [savedData?.occupation],
      fathersName: [savedData?.fathersName || ''],
      mothersName: [savedData?.mothersName || ''],
      firstName: [savedData?.firstName || ''],
      lastName: [savedData?.lastName || ''],
      dateOfBirth: [savedData?.dateOfBirth],
      addressLine1: [savedData?.addressLine1 || ''],
      addressLine2: [savedData?.addressLine2 || ''],
      addressLine3: [savedData?.addressLine3 || ''],
      city: [savedData?.city || ''],
      district: [savedData?.district || ''],
      postCode: [savedData?.postCode || ''],
      country: [savedData?.country || 'BD'],
      email: [this.currentUser?.email || ''],
      emailVerified: [this.currentUser?.emailVerified || false],
      mobile: [savedData?.mobile || ''],
      telephone: [savedData?.telephone || ''],
      fax: [savedData?.fax || ''],
      jointCourtesyTitle: [savedData?.jointCourtesyTitle || ''],
      jointOccupation: [savedData?.jointOccupation || ''],
      jointFathersName: [savedData?.jointFathersName || ''],
      jointMothersName: [savedData?.jointMothersName || ''],
      jointFirstName: [savedData?.jointFirstName || ''],
      jointLastName: [savedData?.jointLastName || ''],
      jointDateOfBirth: [savedData?.jointDateOfBirth || ''],
      jointAddressLine1: [savedData?.jointAddressLine1 || ''],
      jointAddressLine2: [savedData?.jointAddressLine2 || ''],
      jointAddressLine3: [savedData?.jointAddressLine3 || ''],
      jointCity: [savedData?.jointCity || ''],
      jointDistrict: [savedData?.jointDistrict || ''],
      jointPostCode: [savedData?.jointPostCode || ''],
      jointCountry: [savedData?.jointCountry || ''],
      jointEmail: [savedData?.jointEmail || ''],
      jointMobile: [savedData?.jointMobile || ''],
      jointTelephone: [savedData?.jointTelephone || ''],
      jointFax: [savedData?.jointFax || ''],
      nationality: [savedData?.nationality || ''],
      nationalId: [savedData?.nationalId || ''],
      tin: [savedData?.tin || ''],
      brockerBranch: [savedData?.brockerBranch || ''],
      residentialStatus: [savedData?.residentialStatus || ''],

      officerOrSponsor: [savedData?.officerOrSponsor || ''],
      officerCompanyName: [savedData?.officerCompanyName || ''],
      officerDesignation: [savedData?.officerDesignation || ''],
      accountNumber: [savedData?.accountNumber || ''],
      bankObject: [savedData?.bankObject || ''],
      bankCode: [savedData?.bankCode || ''],
      branchName: [savedData?.branchName || ''],
      branchObject: [savedData?.branchObject || ''],
      bankDistrict: [savedData?.bankDistrict || ''],
      bankDistrictCode: [savedData?.bankDistrictCode || ''],
      bankRoutingNumber: [savedData?.bankRoutingNumber || ''],

      nominee1CourtesyTitle: [savedData?.nominee1CourtesyTitle || ''],
      nominee1FirstName: [savedData?.nominee1FirstName || ''],
      nominee1LastName: [savedData?.nominee1LastName || ''],
      nominee1Relation: [savedData?.nominee1Relation || ''],
      nominee1Address: [savedData?.nominee1Address || ''],
      nominee1Percentage: [savedData?.nominee1Percentage || ''],
      nominee1ResidentialStatus: [savedData?.nominee1ResidentialStatus || ''],
      nominee1DateOfBirth: [savedData?.nominee1DateOfBirth || ''],
      nominee1NId: [savedData?.nominee1NId || ''],
      nominee1Nationality: [savedData?.nominee1Nationality || ''],
      nominee1AddressLine1: [savedData?.nominee1AddressLine1 || ''],
      nominee1AddressLine2: [savedData?.nominee1AddressLine2 || ''],
      nominee1AddressLine3: [savedData?.nominee1AddressLine3 || ''],
      nominee1City: [savedData?.nominee1City || ''],
      nominee1PostCode: [savedData?.nominee1PostCode || ''],
      nominee1Division: [savedData?.nominee1Division || ''],
      nominee1Country: [savedData?.nominee1Country || ''],
      nominee1Email: [savedData?.nominee1Email || ''],
      nominee1Mobile: [savedData?.nominee1Mobile || ''],
      nominee1Telephone: [savedData?.nominee1Telephone || ''],
      nominee1Fax: [savedData?.nominee1Fax || ''],
      nominee1FathersName: [savedData?.nominee1FathersName || ''],
      nominee1MothersName: [savedData?.nominee1MothersName || ''],
      nominee1Profession: [savedData?.nominee1Profession || ''],
      nominee1Guardian: [savedData?.nominee1Guardian || false],

      nominee1GuardianCourtesyTitle: [savedData?.nominee1GuardianCourtesyTitle || ''],
      nominee1GuardianFirstName: [savedData?.nominee1GuardianFirstName || ''],
      nominee1GuardianLastName: [savedData?.nominee1GuardianLastName || ''],
      nominee1GuardianRelation: [savedData?.nominee1GuardianRelation || ''],
      nominee1GuardianAddress: [savedData?.nominee1GuardianAddress || ''],
      nominee1GuardianPercentage: [savedData?.nominee1GuardianPercentage || ''],
      nominee1GuardianResidentialStatus: [savedData?.nominee1GuardianResidentialStatus || ''],
      nominee1GuardianDateOfBirth: [savedData?.nominee1GuardianDateOfBirth || ''],
      nominee1GuardianNId: [savedData?.nominee1GuardianNId || ''],
      nominee1GuardianNationality: [savedData?.nominee1GuardianNationality || ''],
      nominee1GuardianAddressLine1: [savedData?.nominee1GuardianAddressLine1 || ''],
      nominee1GuardianAddressLine2: [savedData?.nominee1GuardianAddressLine2 || ''],
      nominee1GuardianAddressLine3: [savedData?.nominee1GuardianAddressLine3 || ''],
      nominee1GuardianCity: [savedData?.nominee1GuardianCity || ''],
      nominee1GuardianPostCode: [savedData?.nominee1GuardianPostCode || ''],
      nominee1GuardianDivision: [savedData?.nominee1GuardianDivision || ''],
      nominee1GuardianCountry: [savedData?.nominee1GuardianCountry || ''],
      nominee1GuardianEmail: [savedData?.nominee1GuardianEmail || '', []],
      nominee1GuardianMobile: [savedData?.nominee1GuardianMobile || ''],
      nominee1GuardianTelephone: [savedData?.nominee1GuardianTelephone || ''],
      nominee1GuardianFax: [savedData?.nominee1GuardianFax || ''],

      nominee2CourtesyTitle: [savedData?.nominee2CourtesyTitle || ''],
      nominee2FirstName: [savedData?.nominee2FirstName || ''],
      nominee2LastName: [savedData?.nominee2LastName || ''],
      nominee2Relation: [savedData?.nominee2Relation || ''],
      nominee2Address: [savedData?.nominee2Address || ''],
      nominee2Percentage: [savedData?.nominee2Percentage || ''],
      nominee2ResidentialStatus: [savedData?.nominee2ResidentialStatus || ''],
      nominee2DateOfBirth: [savedData?.nominee2DateOfBirth || ''],
      nominee2Nationality: [savedData?.nominee2Nationality || ''],
      nominee2NId: [savedData?.nominee2NId || ''],
      nominee2AddressLine1: [savedData?.nominee2AddressLine1 || ''],
      nominee2AddressLine2: [savedData?.nominee2AddressLine2 || ''],
      nominee2AddressLine3: [savedData?.nominee2AddressLine3 || ''],
      nominee2City: [savedData?.nominee2City || ''],
      nominee2PostCode: [savedData?.nominee2PostCode || ''],
      nominee2Division: [savedData?.nominee2Division || ''],
      nominee2Country: [savedData?.nominee2Country || ''],
      nominee2Email: [savedData?.nominee2Email || ''],
      nominee2Mobile: [savedData?.nominee2Mobile || ''],
      nominee2Telephone: [savedData?.nominee2Telephone || ''],
      nominee2Fax: [savedData?.nominee2Fax || ''],
      nominee2FathersName: [savedData?.nominee2FathersName || ''],
      nominee2MothersName: [savedData?.nominee2MothersName || ''],
      nominee2Profession: [savedData?.nominee2Profession || ''],
      nominee2Guardian: [savedData?.nominee2Guardian || false],
      nominee2GuardianCourtesyTitle: [savedData?.nominee2GuardianCourtesyTitle || ''],
      nominee2GuardianFirstName: [savedData?.nominee2GuardianFirstName || ''],
      nominee2GuardianLastName: [savedData?.nominee2GuardianLastName || ''],
      nominee2GuardianRelation: [savedData?.nominee2GuardianRelation || ''],
      nominee2GuardianAddress: [savedData?.nominee2GuardianAddress || ''],
      nominee2GuardianPercentage: [savedData?.nominee2GuardianPercentage || ''],
      nominee2GuardianResidentialStatus: [savedData?.nominee2GuardianResidentialStatus || ''],
      nominee2GuardianDateOfBirth: [savedData?.nominee2GuardianDateOfBirth || ''],
      nominee2GuardianNationality: [savedData?.nominee2GuardianNationality || ''],
      nominee2GuardianNId: [savedData?.nominee2GuardianNId || ''],
      nominee2GuardianAddressLine1: [savedData?.nominee2GuardianAddressLine1 || ''],
      nominee2GuardianAddressLine2: [savedData?.nominee2GuardianAddressLine2 || ''],
      nominee2GuardianAddressLine3: [savedData?.nominee2GuardianAddressLine3 || ''],
      nominee2GuardianCity: [savedData?.nominee2GuardianCity || ''],
      nominee2GuardianPostCode: [savedData?.nominee2GuardianPostCode || ''],
      nominee2GuardianDivision: [savedData?.nominee2GuardianDivision || ''],
      nominee2GuardianCountry: [savedData?.nominee2GuardianCountry || ''],
      nominee2GuardianEmail: [savedData?.nominee2GuardianEmail || ''],
      nominee2GuardianMobile: [savedData?.nominee2GuardianMobile || ''],
      nominee2GuardianTelephone: [savedData?.nominee2GuardianTelephone || ''],
      nominee2GuardianFax: [savedData?.nominee2GuardianFax || ''],
      boAttachment: [savedData?.boAttachment || ''],
      firstApplicantPhotoAttachment: [savedData?.firstApplicantPhotoAttachment || ''],
      nidPassportDrivingBothSideAttachment: [savedData?.nidPassportDrivingBothSideAttachment || ''],
      firstApplicantTINAttachment: [savedData?.firstApplicantTINAttachment || ''],
      firstApplicantBankStatementAttachment: [savedData?.firstApplicantBankStatementAttachment || ''],
      firstApplicantSignatureAttachment: [savedData?.firstApplicantSignatureAttachment || ''],
      nominee1ApplicantPhotoAttachment: [savedData?.nominee1ApplicantPhotoAttachment || ''],
      nominee1ApplicantNIDAttachment: [savedData?.nominee1ApplicantNIDAttachment || ''],
      nominee1ApplicantSignatureAttachment: [savedData?.nominee1ApplicantSignatureAttachment || ''],
      nominee2ApplicantSignatureAttachment: [savedData?.nominee2ApplicantSignatureAttachment || ''],
      nominee2ApplicantPhotoAttachment: [savedData?.nominee2ApplicantPhotoAttachment || ''],
      termsAndConditions: [savedData?.termsAndConditions || false],
    });

    super.buildForm(this.prdname, this.productForm.value, this.currentUser.id);

    this.productForm?.get('bankCode').valueChanges.subscribe((value) => {
      this.productForm.get('branchName').setValue(null);
      this.productForm.get('bankRoutingNumber').setValue('');
      this.loadBranches(value);
    });
    this.productForm?.get('branchName').valueChanges.subscribe((value) => {
      // console.log(value, 'branchName');
      // Update bank routing number when branch is selected
      if (value) {
        const selectedBranch = this.branchOptions.find((branch) => branch?.id === value);
        // console.log(selectedBranch, 'selectedBranch', this.branchOptions);
        this.productForm.get('branchObject').setValue(selectedBranch);
        if (selectedBranch && selectedBranch.routingNumber) {
          this.productForm.get('bankRoutingNumber').setValue(selectedBranch.routingNumber);
          this.productForm.get('bankDistrictCode').setValue(selectedBranch.districtCode);
        }
      } else {
        this.productForm.get('branchObject').setValue(null);
        this.productForm.get('bankRoutingNumber').setValue('');
        this.productForm.get('bankDistrictCode').setValue('');
      }
    });

    // Add form value change listeners to clear errors in real-time
    this.setupFormErrorClearing();

    // Enable validation after form initialization if loading saved data
    if (isInitializing) {
      setTimeout(() => {
        this.enableFormValidation();
      }, 100);
    }
  }

  private enableFormValidation(): void {
    // Re-enable validation for email fields after form initialization
    const emailFields = ['email', 'jointEmail', 'nominee1Email', 'nominee1GuardianEmail', 'nominee2Email', 'nominee2GuardianEmail'];
    emailFields.forEach((fieldName) => {
      const control = this.productForm.get(fieldName);
      if (control) {
        control.updateValueAndValidity();
      }
    });
  }
  async loadBanks() {
    try {
      this.bankInProcessing = true;
      this.bankMasterData = await this.lovDataService.loadBanksData();
      // console.log(this.bankMasterData, 'bankMasterData');
      this.bankOptions = this.bankMasterData.map((item) => {
        return {
          id: item.code,
          text: item.value,
        };
      });
      this.bankOptions.sort((a, b) => (a.text > b.text ? 1 : -1));
      // console.log(this.bankOptions);
      this.bankInProcessing = false;
    } catch (e) {
      this.bankInProcessing = false;
    }
  }
  async loadBranches(bankCode) {
    // console.log(bankCode, 'bankCode');
    let bank = this.bankMasterData.find((item) => item.code === bankCode);
    if (bank) {
      this.productForm.get('bankObject').setValue(bank);
    }
    try {
      this.branchInProcessing = true;
      this.cdRef.detectChanges();
      let branchMasterData = await this.lovDataService.loadBranchesData(bank.id);
      // console.log(branchMasterData, 'branchMasterData');
      this.branchOptions = branchMasterData.map((item) => {
        return {
          id: item.value,
          text: item.value,
          code: item.code,
          routingNumber: item.routingNumber,
          districtCode: item.districtCode,
        };
      });
      this.branchInProcessing = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.branchInProcessing = false;
      this.cdRef.detectChanges();
    }

    // if (!bank) {
    //   this.branchOptions = [];
    //   this.productForm?.get('branchName').setValue(null);
    // } else {
    //   this.branchOptions = bank.innerData.map((item) => {
    //     return {
    //       id: item.code,
    //       text: item.value,
    //     };
    //   });
    //   this.branchOptions = this.branchOptions.sort(function (a, b) {
    //     if (a.text < b.text) {
    //       return -1;
    //     }
    //     if (a.text > b.text) {
    //       return 1;
    //     }
    //     return 0;
    //   });
    // }
  }
  toggleMenu(e) {
    // console.log('ProductSignupComponent: toggleMenu called with:', e);
    this.toggle = e;
  }

  // Step Navigation Event Handlers
  onStepChange(event: { currentIndex: number; previousIndex: number }): void {
    console.log('ProductSignupComponent: Step changed from', event.previousIndex, 'to', event.currentIndex);
    // Validate current step before allowing step change
    if (this.validateCurrentStep()) {
      this.currentStepIndex = event.currentIndex;
      this.currentStep = event.currentIndex + 1; // Convert to 1-based indexing
      this.clearStepError(this.steps[event.previousIndex].id);
    } else {
      // Prevent step change if validation fails
      this.updateStepValidationState();
      this.disableNext = true;
      setTimeout(() => {
        this.disableNext = false;
      }, 2000);
    }
  }

  onStepClick(event: { step: Step; index: number }): void {
    console.log('ProductSignupComponent: Step clicked:', event.step.title, 'at index', event.index);
    this.currentStepIndex = event.index;
    this.currentStep = event.index + 1; // Convert to 1-based indexing
    // Allow navigation to any step without blocking
    this.disableNext = true;
    setTimeout(() => {
      this.disableNext = false;
    }, 2000);
    if (this.validateCurrentStep()) {
      this.clearStepError(this.steps[this.currentStepIndex].id);
    } else {
      this.updateStepValidationState();
    }
  }

  onBack(): void {
    // console.log('ProductSignupComponent: Back button clicked');
    // Validate current step before going back
    if (this.validateCurrentStep()) {
      this.previousStep();
      this.clearStepError(this.steps[this.currentStepIndex].id);
    } else {
      this.updateStepValidationState();
      this.disableNext = true;
      setTimeout(() => {
        this.disableNext = false;
      }, 2000);
    }
  }

  onNext(): void {
    // console.log('ProductSignupComponent: Next button clicked');
    this.loading = true;
    this.clearStepError(this.steps[this.currentStepIndex].id);

    setTimeout(() => {
      this.loading = false;
      this.nextStep();
      ScrollToTop();
    }, 100);
    // Validate current step before proceeding
    if (this.validateCurrentStep()) {
    } else {
      this.updateStepValidationState();
    }
  }

  // Step navigation methods
  nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.currentStepIndex = this.currentStep - 1; // Convert to 0-based indexing
    }
  }

  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.currentStepIndex = this.currentStep - 1; // Convert to 0-based indexing
    }
  }

  async onFinish() {
    // Validate all steps by temporarily setting currentStepIndex
    for (let i = 0; i < this.steps.length; i++) {
      this.currentStepIndex = i;
      this.onNext();
      // await this.validateCurrentStep();
      // await this.validateCurrentStep();
    }

    console.log('ProductSignupComponent: Finish button clicked');
    console.log(this.productForm);
    let invalidFieldErrors = Object.keys(this.productForm.controls)
      .filter((key) => this.productForm.get(key)?.invalid)
      .map((key) => ({
        field: key,
        errors: this.productForm.get(key)?.errors,
      }));

    console.log('Invalid Fields with Errors:', invalidFieldErrors);

    // Validate current step before finishing
    if (this.validateCurrentStep()) {
      this.productForm.markAllAsTouched();
      if (this.productForm.valid) {
        this.submitInProgress = true;
        this.cdRef.detectChanges();
        console.log('ProductSignupComponent: Form is valid');
        try {
          await this.portalProductsService.submitSignupForm(this.productId);
          await this.portalProductsService.getProductStatuses();
        } catch (e) {
          this.submitInProgress = false;
          this.showValidationErrors = true;
          this.disableNext = true;
          setTimeout(() => {
            this.disableNext = false;
          }, 2000);
        }
        // Simulate form submission
        setTimeout(async () => {
          if (
            await ConfirmDialog('Product signup completed successfully!', 'Product signup completed successfully!', 'Go to Dashboard', '')
          ) {
            this.submitInProgress = false;
            this.router.navigate(['/dashboard']);
          }
        }, 500);
      } else {
        console.log('ProductSignupComponent: Form is invalid');
        this.showValidationErrors = true;
        this.updateStepValidationState();
      }
    } else {
      this.loading = false;
      this.submitInProgress = false;
      // this.showValidationErrors = true;
      this.updateStepValidationState();
      this.disableNext = true;
      setTimeout(() => {
        this.disableNext = false;
      }, 2000);
    }
  }

  // Helper methods
  private validateCurrentStep(): boolean {
    this.productForm.markAllAsTouched();
    this.showValidationErrors = this.productForm?.invalid;
    console.log('ProductSignupComponent: Validating current step:', this.currentStepIndex);
    // Add validation logic based on current step
    switch (this.currentStepIndex) {
      case 0: // Account Holder
        return this.validateAccountHolder();

      case 1: // Bank Information
        return this.validateBankInformation();
      case 2: // Nominee Details
        return this.validateNomineeDetails();
      case 3: // Documents
        return this.validateDocuments();
      case 4: // Documents
        return this.validateConfirmation();
      default:
        return true;
    }
  }

  // Step-specific validation methods
  private validateAccountHolder(): boolean {
    console.log('ProductSignupComponent: Validating account holder');

    // Define all account holder field names
    const accountHolderFields = [
      'boType',
      'accountHolderType',
      'courtesyTitle',
      'gender',
      'occupation',
      'fathersName',
      'mothersName',
      'firstName',
      'lastName',
      'dateOfBirth',
      'addressLine1',
      'city',
      'postCode',
      'country',
      'email',
      'emailVerified',
      'mobile',
      'nationality',
      'nationalId',
      'brockerBranch',
      'residentialStatus',
      'officerOrSponsor',
      'jointEmail',
      'telephone',
      'fax',
    ];

    // Mark all fields as touched and collect form controls
    const formControls = accountHolderFields.map((fieldName) => {
      const control = this.productForm.get(fieldName);
      control?.markAsTouched();
      return control;
    });

    // Check if all required fields are valid
    const isValid = formControls.every((control) => control?.valid);

    // Special validation for BO ID if BO type is 'linkBo'
    const boType = this.productForm.get('boType');
    const boId = this.productForm.get('boId');
    const boTypeValid = boType?.value === 'linkBo' ? boId?.valid : true;

    // Mark BO ID as touched if it's required
    if (boType?.value === 'linkBo') {
      boId?.markAsTouched();
    }

    console.log('ProductSignupComponent: Account holder validation 9-18-25:', boId, boType?.value);

    const emailVerified = this.productForm.get('emailVerified');
    // Mark as touched to show validation errors
    emailVerified?.markAsTouched();
    emailVerified?.markAsDirty();

    // If value is false, manually set the control as invalid
    if (emailVerified?.value === false) {
      emailVerified.setErrors({ emailVerified: true });
    } else if (emailVerified?.value === true) {
      // Clear errors if value is true
      emailVerified.setErrors(null);
      console.log('ProductSignupComponent: email verified is true, clearing errors');
    }

    const finalIsValid = isValid && boTypeValid;
    console.log('ProductSignupComponent: Account holder validation result:', finalIsValid);
    return finalIsValid;
  }

  private validateBankInformation(): boolean {
    console.log('ProductSignupComponent: Validating bank information');

    // Get the form controls for step 3 (Bank Information)
    const accountNumber = this.productForm.get('accountNumber');
    const bankCode = this.productForm.get('bankCode');
    const branchName = this.productForm.get('branchName');
    // const bankDistrict = this.productForm.get('bankDistrict');

    // Mark all fields as touched to show validation errors
    accountNumber?.markAsTouched();
    bankCode?.markAsTouched();
    branchName?.markAsTouched();
    // bankDistrict?.markAsTouched();

    // Check if all required fields are valid
    const isValid = accountNumber?.valid && bankCode?.valid && branchName?.valid;

    console.log('ProductSignupComponent: Bank information validation result:', isValid);
    return isValid || false;
  }

  private validateNomineeDetails(): boolean {
    console.log('ProductSignupComponent: Validating nominee details');

    // Define all nominee field names
    const nomineeFields = [
      // Nominee 1 fields
      'nominee1CourtesyTitle',
      'nominee1FirstName',
      'nominee1LastName',
      'nominee1Relation',
      'nominee1Percentage',
      'nominee1ResidentialStatus',
      'nominee1DateOfBirth',
      'nominee1NId',
      'nominee1Nationality',
      'nominee1AddressLine1',
      'nominee1City',
      'nominee1PostCode',
      'nominee1Division',
      'nominee1Country',
      'nominee1Mobile',
      'nominee1Email',
      'nominee1Telephone',
      'nominee1Fax',
      'nominee1FathersName',
      'nominee1MothersName',
      'nominee1Profession',
      // Nominee 1 Guardian fields
      'nominee1Guardian',
      'nominee1GuardianCourtesyTitle',
      'nominee1GuardianFirstName',
      'nominee1GuardianLastName',
      'nominee1GuardianRelation',
      'nominee1GuardianPercentage',
      'nominee1GuardianResidentialStatus',
      'nominee1GuardianDateOfBirth',
      'nominee1GuardianNId',
      'nominee1GuardianNationality',
      'nominee1GuardianAddressLine1',
      'nominee1GuardianCity',
      'nominee1GuardianPostCode',
      'nominee1GuardianDivision',
      'nominee1GuardianCountry',
      'nominee1GuardianMobile',
      'nominee1GuardianEmail',
      'nominee1GuardianTelephone',
      'nominee1GuardianFax',
      // Nominee 2 fields (only contact fields)
      'nominee2CourtesyTitle',
      'nominee2Mobile',
      'nominee2Email',
      'nominee2Telephone',
      'nominee2Fax',
      'nominee2FathersName',
      'nominee2MothersName',
      'nominee2Profession',
      // Nominee 2 Guardian fields (only contact fields)
      'nominee2GuardianMobile',
      'nominee2GuardianEmail',
      'nominee2GuardianTelephone',
      'nominee2GuardianFax',
    ];

    // Mark all fields as touched and collect form controls
    const formControls = nomineeFields.map((fieldName) => {
      const control = this.productForm.get(fieldName);
      control?.markAsTouched();
      if (fieldName === 'nominee1FirstName') {
        console.log('ProductSignupComponent: Nominee 1 First Name:', control);
      }
      return control;
    });

    // Check if all required fields are valid
    const isValid = formControls.every((control) => control?.valid);

    console.log('ProductSignupComponent: Nominee details validation result:', isValid);
    return isValid;
  }

  private validateDocuments(): boolean {
    console.log('ProductSignupComponent: Validating documents');

    // Get the form controls for step 5 (Documents)
    const boAttachment = this.productForm.get('boAttachment');
    const nominee1ApplicantPhotoAttachment = this.productForm.get('nominee1ApplicantPhotoAttachment');
    const firstApplicantPhotoAttachment = this.productForm.get('firstApplicantPhotoAttachment');
    const nidPassportDrivingBothSideAttachment = this.productForm.get('nidPassportDrivingBothSideAttachment');
    const nominee1ApplicantNIDAttachment = this.productForm.get('nominee1ApplicantNIDAttachment');
    const nominee1ApplicantSignatureAttachment = this.productForm.get('nominee1ApplicantSignatureAttachment');
    const nominee2ApplicantSignatureAttachment = this.productForm.get('nominee2ApplicantSignatureAttachment');
    const nominee2ApplicantPhotoAttachment = this.productForm.get('nominee2ApplicantPhotoAttachment');
    const firstApplicantSignatureAttachment = this.productForm.get('firstApplicantSignatureAttachment');
    const firstApplicantTINAttachment = this.productForm.get('firstApplicantTINAttachment');
    const firstApplicantBankStatementAttachment = this.productForm.get('firstApplicantBankStatementAttachment');

    // Mark all fields as touched to show validation errors
    boAttachment?.markAsTouched();
    firstApplicantPhotoAttachment?.markAsTouched();
    nidPassportDrivingBothSideAttachment?.markAsTouched();
    nominee1ApplicantPhotoAttachment?.markAsTouched();
    nominee1ApplicantSignatureAttachment?.markAsTouched();
    nominee2ApplicantSignatureAttachment?.markAsTouched();
    nominee2ApplicantPhotoAttachment?.markAsTouched();
    firstApplicantSignatureAttachment?.markAsTouched();
    firstApplicantTINAttachment?.markAsTouched();
    firstApplicantBankStatementAttachment?.markAsTouched();
    nominee1ApplicantNIDAttachment?.markAsTouched();

    // Check if all required fields are valid and BO type is 'linkBo'
    const boType = this.productForm.get('boType');
    const boTypeValid = boType?.value === 'linkBo' ? boAttachment?.valid : true;
    const isValid =
      boTypeValid &&
      boAttachment?.valid &&
      firstApplicantPhotoAttachment?.valid &&
      nidPassportDrivingBothSideAttachment?.valid &&
      nominee1ApplicantPhotoAttachment?.valid &&
      nominee1ApplicantNIDAttachment?.valid &&
      nominee1ApplicantSignatureAttachment?.valid &&
      nominee2ApplicantSignatureAttachment?.valid &&
      firstApplicantSignatureAttachment?.valid &&
      firstApplicantTINAttachment?.valid &&
      firstApplicantBankStatementAttachment?.valid;

    console.log('ProductSignupComponent: Documents validation result:', isValid);
    return isValid || false;
  }
  validateConfirmation(): boolean {
    console.log('ProductSignupComponent: Validating confirmation');
    const termsAndConditions = this.productForm.get('termsAndConditions');

    // Mark as touched to show validation errors
    termsAndConditions?.markAsTouched();
    termsAndConditions?.markAsDirty();

    // If value is false, manually set the control as invalid
    if (termsAndConditions?.value === false) {
      termsAndConditions.setErrors({ requiredTrue: true });
      console.log('ProductSignupComponent: Terms and conditions is false, setting invalid');
    } else if (termsAndConditions?.value === true) {
      // Clear errors if value is true
      termsAndConditions.setErrors(null);
      console.log('ProductSignupComponent: Terms and conditions is true, clearing errors');
    }

    const isValid = termsAndConditions?.valid;
    console.log('ProductSignupComponent: Confirmation validation result:', isValid);
    console.log('ProductSignupComponent: Terms and conditions value:', termsAndConditions?.value);
    console.log('ProductSignupComponent: Terms and conditions errors:', termsAndConditions?.errors);

    return isValid || false;
  }

  // Get current step content
  getCurrentStepContent(): string {
    const step = this.steps[this.currentStepIndex];
    console.log('ProductSignupComponent: Getting content for step:', step?.id);
    switch (step?.id) {
      case 'personal-details':
        return 'Please provide your personal information including name, contact details, and identification.';
      case 'risk-assessment':
        return 'Complete our risk assessment questionnaire to determine your investment profile.';
      case 'documents':
        return 'Upload required documents such as ID proof, address proof, and income certificates.';
      default:
        return '';
    }
  }

  // Helper method to get step status
  getStepStatus(stepIndex: number): { isActive: boolean; isCompleted: boolean } {
    const stepNumber = stepIndex + 1; // Convert to 1-based indexing
    return {
      isActive: stepNumber === this.currentStep,
      isCompleted: stepNumber < this.currentStep,
    };
  }

  // Update step validation state
  private updateStepValidationState(): void {
    console.log('ProductSignupComponent: Updating step validation state');

    this.steps.forEach((step, index) => {
      if (index === this.currentStepIndex) {
        // Mark current step as having validation error
        step.hasValidationError = true;
        step.isValid = false;

        // Set specific error messages based on step
        this.setStepSpecificErrors(step, index);
      }
      // Don't reset other steps - preserve their existing error states
      // This allows errors to persist when navigating between steps
    });

    console.log('ProductSignupComponent: Step validation state updated:', this.steps);
  }

  // Set step-specific error messages
  private setStepSpecificErrors(step: Step, stepIndex: number): void {
    const errorDetails = this.getDynamicErrorDetails(stepIndex);

    switch (stepIndex) {
      case 0: // Account Holder
        step.errorMessage = step.title;
        step.errorDetails = errorDetails;

      case 1: // Bank Information
        step.errorMessage = step.title;
        step.errorDetails = errorDetails;
        break;
      case 2: // Nominee Details
        step.errorMessage = step.title;
        step.errorDetails = errorDetails;
        break;
      case 3: // Documents
        step.errorMessage = step.title;
        step.errorDetails = errorDetails;
        break;
      case 4: // Submit
        step.errorMessage = step.title;
        step.errorDetails = errorDetails;
        break;
      default:
        step.errorMessage = 'Validation errors found';
        step.errorDetails = errorDetails;
    }
  }

  // Get dynamic error details based on actual form validation errors
  private getDynamicErrorDetails(stepIndex: number): string[] {
    const errorDetails: string[] = [];

    switch (stepIndex) {
      case 0: // Account Holder
        this.addFieldErrorIfInvalid('boType', 'BO Type', errorDetails);
        this.addFieldErrorIfInvalid('boId', 'BO ID', errorDetails, () => this.productForm.get('boType')?.value === 'linkBo');
        this.addFieldErrorIfInvalid('accountHolderType', 'Account Holder Type', errorDetails);
        this.addFieldErrorIfInvalid('courtesyTitle', 'Courtesy Title', errorDetails);
        this.addFieldErrorIfInvalid('gender', 'Gender', errorDetails);
        this.addFieldErrorIfInvalid('occupation', 'Occupation', errorDetails);
        this.addFieldErrorIfInvalid('fathersName', "Father's Name", errorDetails);
        this.addFieldErrorIfInvalid('mothersName', "Mother's Name", errorDetails);
        this.addFieldErrorIfInvalid('firstName', 'First Name', errorDetails);
        this.addFieldErrorIfInvalid('lastName', 'Last Name', errorDetails);
        this.addFieldErrorIfInvalid('dateOfBirth', 'Date of Birth', errorDetails);
        this.addFieldErrorIfInvalid('addressLine1', 'Address Line 1', errorDetails);
        this.addFieldErrorIfInvalid('city', 'City', errorDetails);
        this.addFieldErrorIfInvalid('postCode', 'Post Code', errorDetails);
        this.addFieldErrorIfInvalid('country', 'Country', errorDetails);
        this.addFieldErrorIfInvalid('email', 'Email', errorDetails);
        this.addFieldErrorIfInvalid('emailVerified', 'Email Verified', errorDetails);
        this.addFieldErrorIfInvalid('mobile', 'Mobile', errorDetails);
        this.addFieldErrorIfInvalid('telephone', 'Telephone', errorDetails);
        this.addFieldErrorIfInvalid('fax', 'Fax', errorDetails);
        this.addFieldErrorIfInvalid('nationality', 'Nationality', errorDetails);
        this.addFieldErrorIfInvalid('nationalId', 'National ID', errorDetails);
        this.addFieldErrorIfInvalid('brockerBranch', 'Broker Branch', errorDetails);
        this.addFieldErrorIfInvalid('residentialStatus', 'Residential Status', errorDetails);
        this.addFieldErrorIfInvalid('officerOrSponsor', 'Officer or Sponsor', errorDetails);
        break;

      case 1: // Bank Information
        this.addFieldErrorIfInvalid('accountNumber', 'Account Number', errorDetails);
        this.addFieldErrorIfInvalid('bankCode', 'Bank Name', errorDetails);
        this.addFieldErrorIfInvalid('branchName', 'Branch Name', errorDetails);
        // this.addFieldErrorIfInvalid('bankDistrict', 'Bank District', errorDetails);
        break;

      case 2: // Nominee Details
        this.addFieldErrorIfInvalid('nominee1CourtesyTitle', 'Nominee Courtesy Title', errorDetails);
        this.addFieldErrorIfInvalid('nominee1FirstName', 'Nominee First Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee1LastName', 'Nominee Last Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Relation', 'Nominee Relation', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Percentage', 'Nominee Percentage', errorDetails);
        this.addFieldErrorIfInvalid('nominee1ResidentialStatus', 'Nominee Residential Status', errorDetails);
        this.addFieldErrorIfInvalid('nominee1DateOfBirth', 'Nominee Date of Birth', errorDetails);
        this.addFieldErrorIfInvalid('nominee1NId', 'Nominee National ID', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Nationality', 'Nominee Nationality', errorDetails);
        this.addFieldErrorIfInvalid('nominee1AddressLine1', 'Nominee Address Line 1', errorDetails);
        this.addFieldErrorIfInvalid('nominee1City', 'Nominee City', errorDetails);
        this.addFieldErrorIfInvalid('nominee1PostCode', 'Nominee Post Code', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Division', 'Nominee Division', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Country', 'Nominee Country', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Mobile', 'Nominee Mobile', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Email', 'Nominee Email', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Telephone', 'Nominee Telephone', errorDetails);
        this.addFieldErrorIfInvalid('nominee1Fax', 'Nominee Fax', errorDetails);
        this.addFieldErrorIfInvalid('nominee1FathersName', "Nominee Father's Name", errorDetails);
        this.addFieldErrorIfInvalid('nominee1MothersName', "Nominee Mother's Name", errorDetails);
        this.addFieldErrorIfInvalid('nominee1Profession', 'Nominee Profession', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianCourtesyTitle', 'Nominee Guardian Courtesy Title', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianFirstName', 'Nominee Guardian First Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianLastName', 'Nominee Guardian Last Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianRelation', 'Nominee Guardian Relation', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianPercentage', 'Nominee Guardian Percentage', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianResidentialStatus', 'Nominee Guardian Residential Status', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianDateOfBirth', 'Nominee Guardian Date of Birth', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianNationality', 'Nominee Guardian Nationality', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianNId', 'Nominee Guardian National ID', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianAddressLine1', 'Nominee Guardian Address Line 1', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianCity', 'Nominee Guardian City', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianPostCode', 'Nominee Guardian Post Code', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianDivision', 'Nominee Guardian Division', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianCountry', 'Nominee Guardian Country', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianMobile', 'Nominee Guardian Mobile', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianEmail', 'Nominee Guardian Email', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianTelephone', 'Nominee Guardian Telephone', errorDetails);
        this.addFieldErrorIfInvalid('nominee1GuardianFax', 'Nominee Guardian Fax', errorDetails);
        this.addFieldErrorIfInvalid('nominee2CourtesyTitle', 'Nominee2 Courtesy Title', errorDetails);
        this.addFieldErrorIfInvalid('nominee2FirstName', 'Nominee2 First Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee2LastName', 'Nominee2 Last Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Relation', 'Nominee2 Relation', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Percentage', 'Nominee2 Percentage', errorDetails);
        this.addFieldErrorIfInvalid('nominee2ResidentialStatus', 'Nominee2 Residential Status', errorDetails);
        this.addFieldErrorIfInvalid('nominee2DateOfBirth', 'Nominee2 Date of Birth', errorDetails);
        this.addFieldErrorIfInvalid('nominee2NId', 'Nominee2 National ID', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Nationality', 'Nominee2 Nationality', errorDetails);
        this.addFieldErrorIfInvalid('nominee2AddressLine1', 'Nominee2 Address Line 1', errorDetails);
        this.addFieldErrorIfInvalid('nominee2City', 'Nominee2 City', errorDetails);
        this.addFieldErrorIfInvalid('nominee2PostCode', 'Nominee2 Post Code', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Division', 'Nominee2 Division', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Country', 'Nominee2 Country', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Mobile', 'Nominee2 Mobile', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Email', 'Nominee2 Email', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Telephone', 'Nominee2 Telephone', errorDetails);
        this.addFieldErrorIfInvalid('nominee2Fax', 'Nominee2 Fax', errorDetails);
        this.addFieldErrorIfInvalid('nominee2FathersName', "Nominee2 Father's Name", errorDetails);
        this.addFieldErrorIfInvalid('nominee2MothersName', "Nominee2 Mother's Name", errorDetails);
        this.addFieldErrorIfInvalid('nominee2Profession', 'Nominee2 Profession', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianCourtesyTitle', 'Nominee2 Guardian Courtesy Title', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianFirstName', 'Nominee2 Guardian First Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianLastName', 'Nominee2 Guardian Last Name', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianRelation', 'Nominee2 Guardian Relation', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianPercentage', 'Nominee2 Guardian Percentage', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianResidentialStatus', 'Nominee2 Guardian Residential Status', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianDateOfBirth', 'Nominee2 Guardian Date of Birth', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianNId', 'Nominee2 Guardian National ID', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianNationality', 'Nominee2 Guardian Nationality', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianAddressLine1', 'Nominee2 Guardian Address Line 1', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianCity', 'Nominee2 Guardian City', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianPostCode', 'Nominee2 Guardian Post Code', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianDivision', 'Nominee2 Guardian Division', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianCountry', 'Nominee2 Guardian Country', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianMobile', 'Nominee2 Guardian Mobile', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianEmail', 'Nominee2 Guardian Email', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianTelephone', 'Nominee2 Guardian Telephone', errorDetails);
        this.addFieldErrorIfInvalid('nominee2GuardianFax', 'Nominee2 Guardian Fax', errorDetails);

        this.addFieldErrorIfInvalid(
          'nominee2CourtesyTitle',
          'Nominee2 Courtesy Title',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2FirstName',
          'Nominee2 First Name',
          errorDetails,
          () => this.productForm.get('nominee2Percentage')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2LastName',
          'Nominee2 Last Name',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Relation',
          'Nominee2 Relation',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Percentage',
          'Nominee2 Percentage',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2ResidentialStatus',
          'Nominee2 Residential Status',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2DateOfBirth',
          'Nominee2 Date of Birth',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2NId',
          'Nominee2 National ID',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Nationality',
          'Nominee2 Nationality',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2AddressLine1',
          'Nominee2 Address Line 1',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid('nominee2City', 'Nominee2 City', errorDetails, () => this.productForm.get('nominee2FirstName')?.value);
        this.addFieldErrorIfInvalid(
          'nominee2PostCode',
          'Nominee2 Post Code',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Division',
          'Nominee2 Division',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Country',
          'Nominee2 Country',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Mobile',
          'Nominee2 Mobile',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Email',
          'Nominee2 Email',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Telephone',
          'Nominee Telephone',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid('nominee2Fax', 'Nominee2 Fax', errorDetails, () => this.productForm.get('nominee2FirstName')?.value);
        this.addFieldErrorIfInvalid(
          'nominee2FathersName',
          "Nominee2 Father's Name",
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2MothersName',
          "Nominee2 Mother's Name",
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2Profession',
          'Nominee2 Profession',
          errorDetails,
          () => this.productForm.get('nominee2FirstName')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianCourtesyTitle',
          'Nominee2 Guardian Courtesy Title',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianFirstName',
          'Nominee2 Guardian First Name',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianLastName',
          'Nominee2 Guardian Last Name',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianRelation',
          'Nominee2 Guardian Relation',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianAddress',
          'Nominee2 Guardian Address',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianPercentage',
          'Nominee2 Guardian Percentage',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianResidentialStatus',
          'Nominee2 Guardian Residential Status',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianDateOfBirth',
          'Nominee2 Guardian Date of Birth',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianNId',
          'Nominee2 Guardian National ID',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianNationality',
          'Nominee2 Guardian Nationality',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianAddressLine1',
          'Nominee2 Guardian Address Line 1',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianCity',
          'Nominee2 Guardian City',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianPostCode',
          'Nominee2 Guardian Post Code',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianDivision',
          'Nominee2 Guardian Division',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianCountry',
          'Nominee2 Guardian Country',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianMobile',
          'Nominee2 Guardian Mobile',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        this.addFieldErrorIfInvalid(
          'nominee2GuardianEmail',
          'Nominee2 Guardian Email',
          errorDetails,
          () => this.productForm.get('nominee2Guardian')?.value,
        );
        break;

      case 4: // Documents
        this.addFieldErrorIfInvalid('boAttachment', 'BO Attachment', errorDetails);
        this.addFieldErrorIfInvalid('firstApplicantPhotoAttachment', 'Photo Attachment', errorDetails);
        this.addFieldErrorIfInvalid('nidPassportDrivingBothSideAttachment', 'NID Front Attachment', errorDetails);
        this.addFieldErrorIfInvalid('no', 'NID Rear Attachment', errorDetails);
        this.addFieldErrorIfInvalid('nominee1ApplicantSignatureAttachment', 'Nominee 1 Signature Attachment', errorDetails);
        this.addFieldErrorIfInvalid('nominee2ApplicantSignatureAttachment', 'Nominee 2 Signature Attachment', errorDetails);
        this.addFieldErrorIfInvalid('nominee2ApplicantPhotoAttachment', 'Nominee 2 Photo Attachment', errorDetails);
        this.addFieldErrorIfInvalid('firstApplicantSignatureAttachment', 'Signature Attachment', errorDetails);
        this.addFieldErrorIfInvalid('firstApplicantTINAttachment', 'TIN Attachment', errorDetails);
        this.addFieldErrorIfInvalid('firstApplicantBankStatementAttachment', 'Bank Statement Attachment', errorDetails);
        break;

      case 5: // Confirmation
        this.addFieldErrorIfInvalid('termsAndConditions', 'Terms and Conditions', errorDetails);
        break;
    }

    // If no specific errors found, add a generic message
    if (errorDetails.length === 0) {
      errorDetails.push('Please complete all required fields');
    }

    return errorDetails;
  }

  // Helper method to add field error if invalid
  private addFieldErrorIfInvalid(fieldName: string, displayName: string, errorDetails: string[], condition?: () => boolean): void {
    const control = this.productForm.get(fieldName);

    // Check if condition is met (if provided)
    if (condition && !condition()) {
      return; // Skip validation if condition is not met
    }

    // Check if control exists and is invalid
    if (control && control.invalid && (control.dirty || control.touched)) {
      const errorMessage = this.getFieldErrorMessage(control, displayName);
      if (errorMessage) {
        errorDetails.push(errorMessage);
      }
    }
  }

  // Helper method to get specific error message for a field
  private getFieldErrorMessage(control: any, displayName: string): string {
    if (control.errors) {
      if (control.errors['required']) {
        return `${displayName} is required`;
      }
      if (control.errors['requiredTrue']) {
        return `You must accept the ${displayName}`;
      }
      if (control.errors['email']) {
        return `${displayName} must be a valid email address`;
      }
      if (control.errors['emailVerified']) {
        return `${displayName} must be verified`;
      }
      if (control.errors['minlength']) {
        return `${displayName} must be at least ${control.errors['minlength'].requiredLength} characters`;
      }
      if (control.errors['maxlength']) {
        return `${displayName} must not exceed ${control.errors['maxlength'].requiredLength} characters`;
      }
      if (control.errors['pattern']) {
        return `${displayName} format is invalid`;
      }
      // Add more error types as needed
    }
    return `${displayName} is invalid`;
  }

  // Helper method to manually set errors on completed steps (for demonstration)
  setErrorOnCompletedStep(stepId: string, errorMessage: string, errorDetails?: string[]): void {
    const step = this.steps.find((s) => s.id === stepId);
    if (step && step.completed) {
      step.hasValidationError = true;
      step.errorMessage = errorMessage;
      step.errorDetails = errorDetails || [];
      console.log(`Error set on step ${stepId}:`, errorMessage);
    }
  }

  // Helper method to clear errors from a step
  clearStepError(stepId: string): void {
    const step = this.steps.find((s) => s.id === stepId);
    if (step) {
      step.hasValidationError = false;
      step.errorMessage = undefined;
      step.errorDetails = undefined;
      console.log(`Error cleared from step ${stepId}`);
    }
  }

  // Get all steps with errors
  getStepsWithErrors(): Step[] {
    return this.steps.filter((step) => step.hasValidationError === true);
  }

  collapseSection(sec) {
    this.isCollapseSection[sec] = this.isCollapseSection[sec] === sec ? null : sec;
  }

  // Setup form error clearing in real-time
  private setupFormErrorClearing(): void {
    // Get all form controls
    const formControls = Object.keys(this.productForm.controls);

    formControls.forEach((controlName) => {
      const control = this.productForm.get(controlName);
      if (control) {
        // Subscribe to value changes
        control.valueChanges.subscribe(() => {
          // Clear step error if the current step becomes valid
          if (this.validateCurrentStep()) {
            this.clearStepError(this.steps[this.currentStepIndex].id);
            this.showValidationErrors = false;
          }
        });
      }
    });
  }

  onVerifyEmail(event: any) {
    console.log(event);
    this.productForm.get('emailVerified').setValue(event);
  }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy() {
    // Disable idle logout when component is destroyed
    this.idleLogoutService.disableIdleLogout();
  }
}
